import { IPaginatedList, IReadOptions, Source, AjaxHelper } from '@samc/common';
import { IImportFile } from '@/Interfaces';

export class ImportedFilesSource extends Source<IImportFile> {
  private _helper: AjaxHelper;

  public constructor(url: string) {
    super(Number.MAX_SAFE_INTEGER);
    this._helper = new AjaxHelper(url, '', null, null);
  }

  public files: IImportFile[] = [];

  public async setPackageId(packageId: string) {
    await this.read({ packageId: { filter: packageId } });
  }

  protected async getRows(options: IReadOptions, abortController: AbortController): Promise<IPaginatedList<IImportFile>> {
    if (options.filter === undefined || options.filter['packageId'] === undefined || !options.filter['packageId'].filter) {
      return { items: [], fullCount: 0 };
    }

    this.files = await this._helper.getData<IImportFile[]>('importedfiles', { packageId: options.filter['packageId'].filter }, { signal: abortController.signal });
    return {
      items: this.files,
      fullCount: this.files.length
    };
  }
}